import { LinkableEntityType } from '@api';
import { Anchor } from '@common';

type CompanyAnchorPropsType = {
  company: LinkableEntityType;
  children?: React.ReactNode;
};

export const CompanyAnchor: React.FC<CompanyAnchorPropsType> = ({
  company,
  children,
}) => {
  return (
    <Anchor key={company.id} to={`/companies/$id`} params={{ id: company.id }}>
      {children ?? company.name}
    </Anchor>
  );
};
